import { Qualifier } from "fe-common/graphql";

const qualifierToId = (q: Qualifier) => {
  let range = null;
  if (q.range && q.range.high)
    range = `${q.range.low}_${q.range.high}_${q.range.units}`;
  return q.relation.id + "_" + (range || q.value?.id);
};

export const isQualifierEqual = (q1: Qualifier, q2: Qualifier) =>
  qualifierToId(q1) === qualifierToId(q2);
